import { t } from "@lingui/core/macro";
import { useAtomValue } from "jotai";
import React from "react";

import { AlertIcon } from "@whoosh/design-system/src/components/icons_v2/general";
import {
  Box,
  HStack,
  Text,
} from "@whoosh/design-system/src/components/primitive";

import { isInAllowedGroupSizesAtom } from "../atoms/eventSignUpProcess";

type AllowedGroupSizesWarningProps = {
  allowedGroupSizes: readonly (number | null | undefined)[];
};

export const AllowedGroupSizesWarning = ({
  allowedGroupSizes,
}: AllowedGroupSizesWarningProps) => {
  const isInAllowedGroupSizes = useAtomValue(isInAllowedGroupSizesAtom);
  if (isInAllowedGroupSizes) {
    return null;
  }

  const sortedAllowedGroupSizes = allowedGroupSizes
    .map((allowedGroupSize) => allowedGroupSize)
    .sort((a, b) => (a || 0) - (b || 0));
  const lastSize = sortedAllowedGroupSizes.pop();
  const sizeLabels =
    sortedAllowedGroupSizes.length === 0
      ? lastSize
      : [sortedAllowedGroupSizes.join(`, `), lastSize].join(` or `);

  const patronIndentifier = sizeLabels === 1 ? t`person` : t`people`;

  return (
    <Box bg="surface-status-error-subtle" px={4} py={2} borderRadius="2">
      <HStack alignItems="center" gap={3}>
        <AlertIcon />
        <Text variant="mainTiny" color="text-error-inverse">
          {t`Group must contain `}
          {sizeLabels}
          &nbsp;
          {patronIndentifier}
        </Text>
      </HStack>
    </Box>
  );
};
